import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";
import { IconUpLoad } from "../../../../assets/icon";
import ModalPreviewPost from "../other/ModalPreviewPost";
import { templatesMessageSelector } from "../../../../services/selector/index.";
import BaseButton from "../../Button/BaseButton";
import LabelInput from "../../LabelInput";
import EditorText from "../../EditorText";
import InputText from "../../Input/InputText";
import {
  getTemplatesMessageDetail,
  setOpenEditTemplatesMessage,
  updateTemplatesMessage,
} from "../../../../services/slice/TemplatesMessage";
import TextArea from "antd/lib/input/TextArea";

const ModalEditTemplatesMessage = ({ title }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const templatesMessageState = useSelector(templatesMessageSelector);
  const { idTemplatesMessage, dataTemplateMessageDetail } =
    templatesMessageState;

  const [openPreview, setOpenPreview] = useState(false);
  const [datapost, setDataPost] = useState({
    title: "",
    content: "",
  });

  const [error, setError] = useState({
    isError: false,
    msg: "",
  });

  useEffect(() => {
    if (idTemplatesMessage) {
      dispatch(getTemplatesMessageDetail(idTemplatesMessage));
    }
  }, [dispatch]);

  useEffect(() => {
    setDataPost({
      title: dataTemplateMessageDetail.title,
      content: dataTemplateMessageDetail?.content,
      id: dataTemplateMessageDetail?.id,
    });
  }, [dataTemplateMessageDetail]);

  const handleSave = () => {
    if (
      !datapost.title ||
      datapost.content === "<p><br></p>" ||
      !datapost.content
    ) {
      setError({
        isError: true,
        msg: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }
    setError({
      isError: false,
      msg: "",
    });
    const formPost = new FormData();
    formPost.append("title", datapost.title);
    formPost.append("id", Number(datapost?.id));
    formPost.append(
      "content",
      // datapost.content.replace(
      //   new RegExp(window.SERVER_URL, "g"),
      //   window.SERVER_CLIENT_URL
      // )
      datapost.content
    );
    dispatch(updateTemplatesMessage({ formPost, datapost }));
  };

  const handCancel = () => {
    dispatch(setOpenEditTemplatesMessage({ isOpen: false, id: "" }));
  };
  const handleClickPreview = () => {
    if (datapost.content && datapost.title) setOpenPreview(true);
    else return;
  };
  return (
    <>
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t(title)}
        centered
        width={1300}
        open={templatesMessageState.isOpenModalEditTemplatesMessage}
        // onOk={() => setOpen(false)}
        onCancel={handCancel}
        footer={[
          <BaseButton
            content={"Hủy"}
            width={140}
            typeBtn="btnOrange"
            handleClick={handCancel}
          />,
          // <BaseButton
          //   content={"Xem trước"}
          //   width={140}
          //   typeBtn="btnOrange"
          //   icon={<IconEye fill="white" />}
          //   handleClick={handleClickPreview}
          // />,
          <BaseButton
            content={"Lưu"}
            width={140}
            typeBtn="btnOrange"
            icon={<IconUpLoad />}
            handleClick={handleSave}
          />,
        ]}
      >
        {openPreview && (
          <ModalPreviewPost
            open={openPreview}
            setOpen={setOpenPreview}
            data={datapost}
          />
        )}
        <Row
          style={{
            margin: "1.5rem 0",
            display: "flex",
          }}
        >
          <Col span={24}>
            Hãy thêm cấu hình văn bản để chèn nhanh câu trả lời nhé. Tiêu đề
            phải bao gồm tối thiểu 3 ký tự.
          </Col>
        </Row>
        <Row
          style={{
            margin: "1.5rem 0",
            display: "flex",
          }}
          align={"middle"}
        >
          <Col span={3}>
            <LabelInput style={{ textAlign: "start" }} text={"Tiêu đề"} />
          </Col>
          <Col span={21}>
            <InputText
              maxLength={155}
              focus
              key={"inputTitle"}
              text={datapost.title}
              setText={(value) => setDataPost({ ...datapost, title: value })}
              placeholder={"Nhập tiêu đề tin nhắn"}
              typeInput={`${
                !datapost.title && error.isError ? "checkEmptyText" : null
              }`}
            />
          </Col>
        </Row>
        <Row
          style={{
            margin: "1.5rem 0",
            display: "flex",
          }}
        >
          <Col span={3}>
            <LabelInput
              style={{ textAlign: "start" }}
              text={"Nội dung tin nhắn"}
            />
          </Col>
          <Col span={21}>
            {/* <EditorText
              text={datapost.content}
              height={180}
              placeholder={"Nhập nội dung tin nhắn"}
              setText={setDataPost}
              type={`${
                (!datapost.content || datapost.content === "<p><br></p>") &&
                error.isError
                  ? "checkEmptyText"
                  : null
              }`}
            /> */}
            <TextArea
              value={datapost.content}
              onChange={(e) => {
                setDataPost({ ...datapost, content: e.target.value });
              }}
              style={{ height: 180 }}
              placeholder="Nhập nội dung tin nhắn"
              className={`${
                (!datapost.content || datapost.content === "<p><br></p>") &&
                error.isError
                  ? "checkEmptyText"
                  : ""
              }`}
            />
          </Col>
        </Row>
        {error.isError ? (
          <small className="msgError">{t(error.msg)}</small>
        ) : null}
      </Modal>
    </>
  );
};

export default ModalEditTemplatesMessage;
